var map = {
	"./calendar.svg": 59530,
	"./checkmark.svg": 4411,
	"./circle-down.svg": 50605,
	"./circle-left.svg": 72854,
	"./circle-right.svg": 67253,
	"./circle-up.svg": 50098,
	"./credit-card.svg": 8218,
	"./cross.svg": 28832,
	"./envelope-regular.svg": 72343,
	"./facebook.svg": 46908,
	"./gift-store.svg": 7486,
	"./gift.svg": 40474,
	"./history.svg": 38784,
	"./info.svg": 42436,
	"./lock.svg": 50589,
	"./power.svg": 30347,
	"./printer.svg": 49604,
	"./question.svg": 86436,
	"./spinner.svg": 12759,
	"./star-solid.svg": 71702,
	"./store.svg": 66867,
	"./tag.svg": 61832,
	"./twitter.svg": 1885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71327;